(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["inspirely-corporate-content"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    const link = event.target.closest('[data-corporate-interest]');
    if (!link) return;
    const field = document.querySelector('.ic-form select[name="contact[Which option interests you?]"]');
    if (!field) return;
    const option = Array.from(field.options).find(item => item.value === link.dataset.corporateInterest);
    if (option) {
      field.value = option.value;
      field.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  } catch(e) { console.error(e); }
})();
})();
